exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".create-or-edit-mortgage-component .ant-tabs-nav .ant-tabs-tab {\n  height: auto;\n}", ""]);

// exports
